import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import KloudlessAccountAppResource from "./KloudlessAccountAppResource";

export const SERVICE = {
    calendar: {
        google_calendar: '48cadda4-1be6-43f2-8bf5-d4099ddf6683',
        icloud_calendar: '1c92a766-a932-486c-9eb6-8bd12df4042d',
        outlook_calendar: 'ee564ad9-e6d2-4be3-97c5-0fc023eb1b19',
    },
};

class KloudlessServiceAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'kloudless-service';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'kloudless/services';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'type',
            'slug',
            'name',
            'accounts',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            accounts: KloudlessAccountAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            accounts: 'kloudless_service_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            type: {
                type: 'string',
                presence: true,
            },
            slug: {
                type: 'string',
                presence: true,
            },
            name: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default KloudlessServiceAppResource;
